// Firebase gives no reliable way to tell "signed in with a password" apart from "signed in via
// the passwordless email link" after the fact - both report providerId "password" everywhere
// (user.providerData, getIdTokenResult().signInProvider, etc.), since the email link is just a
// sub-mode of the same Email/Password provider under the hood, not a distinct provider. So
// Login.js records which method was actually used at the moment each sign-in succeeds, and that's
// read back wherever it matters (e.g. hiding "Change Password" in Profile for an email-link-only
// session, since there's no password to reauthenticate with in that case).
//
// Stored in localStorage (not sessionStorage) so it survives exactly as long as Firebase's own
// default "local" auth persistence does - carrying over page refreshes and new tabs on the same
// signed-in browser, not just the tab that completed the sign-in. Cleared on logout (AppNavBar.js)
// so a stale value can never outlive the session that set it.
const SIGN_IN_METHOD_KEY = "lastSignInMethod";

export const SIGN_IN_METHOD = {
  PASSWORD: "password",
  EMAIL_LINK: "emailLink",
};

export function recordSignInMethod(method) {
  window.localStorage.setItem(SIGN_IN_METHOD_KEY, method);
}

export function getSignInMethod() {
  return window.localStorage.getItem(SIGN_IN_METHOD_KEY);
}

export function clearSignInMethod() {
  window.localStorage.removeItem(SIGN_IN_METHOD_KEY);
}
